import { InsightGenericData, MonetaryInsight, OrdersInsight, SalesInsight } from '../types';

export enum RejectionReason {
  'AUTOMATIC' = 'AUTOMATIC',
  'OTHER' = 'OTHER',
  'VENUE' = 'VENUE',
}

export type RejectionTotal = SalesInsight &
  OrdersInsight & {
    items: number;
  };

export type RejectionData<L1, L2 = never, L3 = never> = {
  label: L1 | null;
  total: RejectionTotal;
  split?: RejectionData<L2, L3>[] | null;
};

/** e.g. "2023-05-15" */
type DateString = string;

export type RejectionInsight = InsightGenericData &
  MonetaryInsight & {
    data: {
      rejections: RejectionData<null, DateString, RejectionReason> | null;
    };
  };

export type TotalRejectedOrdersInsight = InsightGenericData & {
  data: {
    rejections: { total: { orders: number } } | null;
  };
};
